// ✅ Updated printAppointmentSlip - Printed timestamp reduced, centered, and moved to end

export const printAppointmentSlip = async (appt) => {
  if (!appt) return alert("Invalid appointment");

  const logoBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUh..."; // Replace with real logo

  const watermark = `
    <svg width="600" height="600" opacity="0.06" style="position:absolute;top:15%;left:12%;">
      <image href="${logoBase64}" width="350" height="350" />
    </svg>
  `;

  const printedAt = new Date().toLocaleString();

  // ✅ Convert time to 12-hour format
  const formatTime12Hour = (time24) => {
    if (!time24) return "-";
    const [hours, minutes] = time24.split(":");
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const html = `
  <html>
  <head>
    <title>Appointment Slip</title>
    <style>
      body {
        background:#fff;
        font-family: Arial;
        padding: 20px;
      }
      .card {
        width: 480px;
        margin: auto;
        background:white;
        border-radius:8px;
        padding:20px;
        position:relative;
        overflow:hidden;
        box-shadow:0 0 8px rgba(0,0,0,0.15);
      }
      .header {
        background:#0f6b70;
        padding:14px;
        color:white;
        border-radius:6px;
        text-align:center;
      }
      .signature-box {
        border-top:1px dashed #666;
        width:150px;
        text-align:center;
        margin-top:20px;
        padding-top:6px;
        font-size:13px;
      }
      .separator {
        border-top: 2px solid #0f6b70;
        margin: 20px 0;
      }
      .developer-credit {
        text-align: center;
        margin-top: 20px;
        padding-top: 10px;
        border-top: 1px solid #ddd;
        font-size: 11px;
        color: #666;
      }
      /* ✅ Reduced size for printed timestamp */
      .printed-timestamp {
        text-align: center;
        font-size: 9px;
        color: #999;
        margin-top: 10px;
      }
    </style>
  </head>

  <body>
    <div class="card">

      <div style="position:absolute; top:0; left:0; width:100%; height:100%; z-index:-1;">
        ${watermark}
      </div>

      <div class="header">
        <h2 style="margin:0">Zainab Medical & Children Care Centre</h2>
        <div>OPD Appointment Slip</div>
      </div>

      <h3>Patient Information</h3>
      <p><strong>MR-Code:</strong> ${appt.mrCode}</p>
      <p><strong>Name:</strong> ${appt.pName}</p>
      <p><strong>Father Name:</strong> ${appt.fatherName}</p>
      <p><strong>Department:</strong> ${appt.department}</p>
      <p><strong>Doctor:</strong> ${appt.doctor?.name || "-"}</p>
      <p><strong>Appt #:</strong> ${appt.appointmentNumber || "-"}</p>

      <!-- Separator line between sections -->
      <div class="separator"></div>

      <h3>Appointment Schedule</h3>
      <p><strong>Date:</strong> ${appt.date}</p>
      <p><strong>Time:</strong> ${formatTime12Hour(appt.time)}</p>

      <div style="display:flex; justify-content:space-between;">
        <div class="signature-box">Admin Signature</div>
        <div class="signature-box">Doctor Signature</div>
      </div>

      <p style="text-align:center; margin-top:15px; font-size:12px;">
        Contact: +923152189910 (Whatsapp Only) / +923153051011 · www.shoaibhospital.cloud
      </p>

      <!-- Developer credit section -->
      <div class="developer-credit">
        Computer Software Developed by Bilal Consultancy, Ph: +92 315 2311183
      </div>

      <!-- ✅ Printed timestamp moved to the very end with smaller size and center alignment -->
      <div class="printed-timestamp">
        Printed: ${printedAt}
      </div>
    </div>

    <script>window.onload = () => window.print();</script>
  </body>
  </html>
  `;

  const w = window.open("", "_blank");
  w.document.write(html);
  w.document.close();
};